export default __webpack_public_path__ + "static/media/AWS_logo_RGB_BLK.ae33a75b.svg";